import {BeautyProfileList} from "components/general-settings/beauty-profile-list/BeautyProfileList";
import {useLocation, useSearchParams} from "react-router-dom";
import {getAllQueryParams, setQueryParams} from "utils/utils";
import {INITIAL_DATA_FILTER} from "configs/general-settings/configTableBeautyProfileList";
import {useEffect, useState} from "react";
import {useFetch} from "services/useFetch";
import {Alert} from "avo-ui";
import {API_BEAUTY_PROFILE} from "services/apiBeautyProfile";

export const BeautyProfileListContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [showModalDelete, setShowModalDelete] = useState(false)
    const [deleteId, setDeleteId] = useState(null)
    const { fetching: getBeautyProfileList, data: beautyProfileList, isLoading } = useFetch(API_BEAUTY_PROFILE.LIST)
    const { fetching: deleteBeautyProfile, isLoading: isDeleting } = useFetch(API_BEAUTY_PROFILE.DELETE)

    useEffect(() => {
        fetchBeautyProfileList()
    }, [location?.search])

    const onShowModalDelete = (id) => {
        setDeleteId(id)
        setShowModalDelete(true)
    }

    const onHideModalDelete = () => {
        setShowModalDelete(false)
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchBeautyProfileList = (item = { ...query }) => {
        getBeautyProfileList(item)
    }

    const onDelete = () => {
        deleteBeautyProfile({}, deleteId).then(() => {
            if (beautyProfileList?.data?.results?.length === 1 && Number(query?.page) !== 1) {
                onChangeQuery({ page: 1 })
            } else {
                fetchBeautyProfileList()
            }

            setShowModalDelete(false)
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'Beauty Profile Deleted !',
            })
        })
    }

    const props = {
        dataList: beautyProfileList?.data,
        query,
        onChangeQuery,
        onDelete,
        showModalDelete,
        onShowModalDelete,
        onHideModalDelete,
        isDeleting,
        isLoading,
    }

    return (
        <BeautyProfileList {...props}/>
    )
}
